import React from 'react'
import { useEffect, useState } from "react";
import { FiPhone } from "react-icons/fi";
import { GoPerson } from "react-icons/go";
import { LuBuilding2 } from "react-icons/lu";
import { TfiReceipt } from "react-icons/tfi";
import { MdOutlineAlternateEmail } from "react-icons/md";
import ModalElement from "../../../Common/ModalElement"
import InputElement from "../../../Common/InputElement";
import ButtonElement from "../../../Common/ButtonElement";
import SearchableDropdown from "../../../Common/SearchDropdown";
import Uploader from "../../../Common/Uploader";
import { validateFields, commonOnChange, commonOnSelect, isValidObject, showToast } from "../../../utils";
import { dropdownDefaultList } from "../../../constants";
import { useApiRequest } from '../../../hooks/useApiRequest';
import { appApis } from '../../../constants';

const AddBilingCompany = ({ show, hideModal, onSuccess, companyData }) => {
    const [details, setDetails] = useState({
        companyName: "",
        gstType: "",
        gstNumber: "",
        mobileNo: "",
        email: "",
        address: "",
        bankAccountNo: "",
        bankAccountName: "",
        bankName: "",
        branchName: "",
        ifscCode: "",
        companyStamp: "",
        companyDigitalSign: "",
        companyNameErr: "",
        gstTypeErr: "",
        gstNumberErr: "",
        mobileNoErr: "",
        emailErr: "",
        addressErr: "",
        bankAccountNoErr: "",
        bankAccountNameErr: "",
        bankNameErr: "",
        branchNameErr: "",
        ifscCodeErr: "",
        hsn_code: "",
        hsn_codeErr: "",
        sac_code: "",
        sac_codeErr: "",
        companyStampErr: "",
        companyDigitalSignErr: ""
    });
    const { request, loading } = useApiRequest();

    // Track file changes using state instead of refs
    const [fileChanges, setFileChanges] = useState({
        companyStamp: false,
        companyDigitalSign: false
    });

    const { companyName, gstType, gstNumber, mobileNo, email, address, bankAccountNo, bankAccountName, bankName, branchName, ifscCode, companyStamp, companyDigitalSign, companyNameErr, gstTypeErr, gstNumberErr, mobileNoErr, emailErr, addressErr, bankAccountNoErr, bankAccountNameErr, bankNameErr, branchNameErr, ifscCodeErr, hsn_code, hsn_codeErr, sac_code, sac_codeErr } = details;

    // Populate form when editing
    useEffect(() => {
        if (companyData) {
            setDetails(prev => ({
                ...prev,
                companyName: companyData.companyName || "",
                gstType: companyData.gstType || "",
                gstNumber: companyData.gstNumber || "",
                mobileNo: companyData.mobileNo || "",
                email: companyData.email || "",
                address: companyData.address || "",
                bankAccountNo: companyData.bankAccountNo || "",
                bankAccountName: companyData.bankAccountName || "",
                bankName: companyData.bankName || "",
                branchName: companyData.branchName || "",
                ifscCode: companyData.ifscCode || "",
                hsn_code: companyData.hsn_code || companyData.hsnCode || "",
                sac_code: companyData.sac_code || companyData.sacCode || "",
                companyStamp: companyData.companyStamp || "",
                companyDigitalSign: companyData.companyDigitalSign || "",
            }));

            // Reset file change tracking
            setFileChanges({
                companyStamp: false,
                companyDigitalSign: false
            });
        }
    }, [companyData, show]);

    const onChangeHandler = (event) => commonOnChange(event, setDetails);
    const onSelectHandler = (event) => commonOnSelect(event, setDetails);

    const submit = () => {
        const gstFields = gstType == "GST" ? {
            gstNumberErr: [gstNumber, "text"],
            hsn_codeErr: [hsn_code, "text"],
            sac_codeErr: [sac_code, "text"],
        } : {}
        validateFields(
            {
                companyNameErr: [companyName, "text"],
                gstTypeErr: [gstType, "text"],
                ...gstFields,
                mobileNoErr: [mobileNo, "phone"],
                emailErr: [email, "email"],
                addressErr: [address, "text"],
                bankAccountNoErr: [bankAccountNo, "text"],
                bankAccountNameErr: [bankAccountName, "text"],
                bankNameErr: [bankName, "text"],
                branchNameErr: [branchName, "text"],
                ifscCodeErr: [ifscCode, "text"],
            },
            setDetails,
            () => {
                const obj = {
                    companyName,
                    gstType,
                    gstNumber: gstNumber || null,
                    email,
                    address,
                    mobileNo,
                    bankAccountName,
                    bankAccountNo,
                    bankName,
                    branchName,
                    ifscCode,
                    hsnCode: gstType === "GST" ? hsn_code : null,
                    sacCode: gstType === "GST" ? sac_code : null,
                }

                // Handle file fields based on create vs edit
                if (!companyData?.billingCompanyId) {
                    // CREATE: Always include files if they exist
                    if (companyStamp) {
                        obj.companyStamp = companyStamp;
                    }
                    if (companyDigitalSign) {
                        obj.companyDigitalSign = companyDigitalSign;
                    }
                } else {
                    // EDIT: Only include files if they were actually changed/uploaded
                    if (fileChanges.companyStamp) {
                        obj.companyStamp = companyStamp;
                    }
                    if (fileChanges.companyDigitalSign) {
                        obj.companyDigitalSign = companyDigitalSign;
                    }
                }

                request(
                    {
                        url: companyData?.billingCompanyId ? `${appApis.updateBillingCompany}/${companyData.billingCompanyId}` : appApis.addBillingCompany,
                        body: obj,
                        method: "POST",
                        onSuccess: () => {
                            onSuccess();
                            hideModal();
                        }
                    }
                )
            }
        )
    }

    return <ModalElement size="lg" show={show} title={`${companyData?.billingCompanyId ? "Edit" : "Add"} Billing Company`} onHide={hideModal} FooterComponent={<div className="submit-btn text-center" style={{ position: 'absolute', bottom: '0px', left: '0', right: '0', background: 'white', padding: '15px', borderTop: '1px solid #dee2e6' }}>
        <ButtonElement loading={loading} text={"Submit"} cssClass="small-radius mb-1" onClick={submit} variant="btn-outline-primary" />
    </div>}>
        <div className="add-company text-start mb-5" >
            <div className="company-details mb-3">
                <h5 className="mb-3">Biling Details</h5>
                <div className="row">
                    <div className="col-lg-4 col-md-6 mb-2">
                        <InputElement
                            label={"Company Name"}
                            placeholder={"Enter Company Name"}
                            name={"companyName"}
                            value={companyName}
                            error={companyNameErr}
                            icon={<LuBuilding2 size={20} />}
                            onChange={onChangeHandler}
                        />
                    </div>
                    <div className="col-lg-4 col-md-6 mb-2">
                        <SearchableDropdown
                            label={"GST type"}
                            placeholder={"Select GST Type"}
                            value={gstType}
                            error={gstTypeErr}
                            options={dropdownDefaultList.gstStatus}
                            onSelect={(value) => onSelectHandler({ target: { name: "gstType", value } })}
                        />
                    </div>
                    {gstType == "GST" ? <div className="col-lg-4 col-md-6 mb-2">
                        <InputElement
                            label={"GST Number"}
                            placeholder={"Enter GST Number"}
                            name={"gstNumber"}
                            value={gstNumber}
                            error={gstNumberErr}
                            icon={<TfiReceipt size={20} />}
                            onChange={onChangeHandler}
                        />
                    </div> : null}
                    {gstType == "GST" ? <div className="col-lg-4 col-md-6 mb-2">
                        <InputElement
                            label={"HSN Code"}
                            placeholder={"Enter HSN Code"}
                            name={"hsn_code"}
                            value={hsn_code}
                            error={hsn_codeErr}
                            onChange={onChangeHandler}
                        />
                    </div> : null}
                    {gstType == "GST" ? <div className="col-lg-4 col-md-6 mb-2">
                        <InputElement
                            label={"SAC Code"}
                            placeholder={"Enter SAC Code"}
                            name={"sac_code"}
                            value={sac_code}
                            error={sac_codeErr}
                            onChange={onChangeHandler}
                        />
                    </div> : null}
                </div>
            </div>
            <div className="company-contact mb-3">
                <h5 className="mb-3">Contact Details</h5>
                <div className="row">
                    <div className="col-lg-6 col-md-6 mb-2">
                        <InputElement
                            label={"Mobile No"}
                            placeholder={"Enter Mobile No"}
                            name={"mobileNo"}
                            value={mobileNo}
                            maxLen="10"
                            error={mobileNoErr}
                            icon={<FiPhone size={20} />}
                            onChange={onChangeHandler}
                        />
                    </div>
                    <div className="col-lg-6 col-md-6 mb-2">
                        <InputElement
                            label={"Email ID"}
                            placeholder={"Enter Email Id"}
                            name={"email"}
                            value={email}
                            error={emailErr}
                            icon={<MdOutlineAlternateEmail size={20} />}
                            onChange={onChangeHandler}
                        />
                    </div>
                    <div className="col-12 mt-2">
                        <InputElement
                            isTextArea={true}
                            label={"Address"}
                            placeholder={"Enter Address"}
                            name={"address"}
                            value={address}
                            error={addressErr}
                            onChange={onChangeHandler}
                        />
                    </div>
                </div>
            </div>
            <div className="row">
                <h5 className="mb-3">Bank Details</h5>
                <div className="col-lg-4 col-md-6 mb-2">
                    <InputElement
                        label={"Account Holder's Name"}
                        placeholder={"Enter Bank Account Name"}
                        name={"bankAccountName"}
                        value={bankAccountName}
                        error={bankAccountNameErr}
                        icon={<GoPerson size={20} />}
                        onChange={onChangeHandler}
                    />
                </div>
                <div className="col-lg-4 col-md-6 mb-2">
                    <InputElement
                        label={"Account No"}
                        placeholder={"Enter Bank Account No"}
                        name={"bankAccountNo"}
                        value={bankAccountNo}
                        error={bankAccountNoErr}
                        onChange={onChangeHandler}
                    />
                </div>
                <div className="col-lg-4 col-md-6 mb-2">
                    <InputElement
                        label={"Bank Name"}
                        placeholder={"Enter Bank Name"}
                        name={"bankName"}
                        value={bankName}
                        error={bankNameErr}
                        onChange={onChangeHandler}
                    />
                </div>
                <div className="col-lg-4 col-md-6 mb-2">
                    <InputElement
                        label={"Branch Name"}
                        placeholder={"Enter Branch Name"}
                        name={"branchName"}
                        value={branchName}
                        error={branchNameErr}
                        onChange={onChangeHandler}
                    />
                </div>
                <div className="col-lg-4 col-md-6 mb-2">
                    <InputElement
                        label={"IFSC Code"}
                        placeholder={"Enter IFSC Code"}
                        name={"ifscCode"}
                        value={ifscCode}
                        error={ifscCodeErr}
                        required={true}
                        onChange={onChangeHandler}
                    />
                </div>
            </div>
            <div className="company-address mt-3 mb-3">
                <h5 className="mb-3">Documents</h5>
                <div className="row">
                    <div className="col-lg-6 col-md-6 mb-2">
                        <Uploader
                            label="Company Digital Sign"
                            acceptType="image/*"
                            initialFileName={companyDigitalSign ? (typeof companyDigitalSign === 'string' ? companyDigitalSign.split('/').pop() : companyDigitalSign.name) : ""}
                            isEdit={!!companyData?.billingCompanyId}
                            setData={(file, fileName) => {
                                setDetails(prev => ({
                                    ...prev,
                                    companyDigitalSign: file,
                                    companyDigitalSignErr: ""
                                }));
                                // Mark file as changed using state
                                setFileChanges(prev => ({
                                    ...prev,
                                    companyDigitalSign: true
                                }));
                            }}
                        />
                    </div>
                    <div className="col-lg-6 col-md-6 mb-2">
                        <Uploader
                            label="Company Stamp"
                            acceptType="image/*"
                            initialFileName={companyStamp ? (typeof companyStamp === 'string' ? companyStamp.split('/').pop() : companyStamp.name) : ""}
                            isEdit={!!companyData?.billingCompanyId}
                            setData={(file, fileName) => {
                                setDetails(prev => ({
                                    ...prev,
                                    companyStamp: file,
                                    companyStampErr: ""
                                }));
                                // Mark file as changed using state
                                setFileChanges(prev => ({
                                    ...prev,
                                    companyStamp: true
                                }));
                            }}
                        />
                    </div>
                </div>
            </div>
        </div>
    </ModalElement>
}

export default AddBilingCompany;
